/**
 * DevicesSoundTest Constants
 */

import type { AudioType } from 'Modules/softphone/services/AudioService';

/**
 * The sounds, grouped by what a tester is actually checking.
 *
 * Twelve DTMF tones next to four call sounds in one flat grid meant the tones
 * dominated the tab and pushed the device lists below the fold, while being the
 * thing least often tested. Grouping lets DTMF stay collapsed by default.
 *
 * `remoteAudio` is absent on purpose: it is the call audio element rather than
 * a sound the panel can meaningfully start and stop.
 */
export const SOUND_GROUPS: {
  name: string;
  types: AudioType[];
  defaultOpen: boolean;
}[] = [
  {
    name: 'Call',
    types: [
      'ringtone',
      'ringback',
      'callDisconnected',
      'lostConnection',
      'secondIncoming',
    ],
    defaultOpen: true,
  },
  {
    name: 'Video',
    types: ['videoStart', 'videoJoin', 'videoLeave', 'videoEnded'],
    defaultOpen: false,
  },
  {
    name: 'DTMF',
    types: [
      'dtmf0',
      'dtmf1',
      'dtmf2',
      'dtmf3',
      'dtmf4',
      'dtmf5',
      'dtmf6',
      'dtmf7',
      'dtmf8',
      'dtmf9',
      'dtmfStar',
      'dtmfPound',
    ],
    defaultOpen: false,
  },
];
